export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_danza-sportiva-send/artifacts/pe0httm2_LMKT%20trasparente.png";

export const HERO_BG_URL =
  "https://static.prod-images.emergentagent.com/jobs/2042ea78-16d0-4782-8481-f5ca5d6ecf3f/images/452c806bdcf8ae7d3051fecdeb2a3bb1b8125133ef720cab11b6cb539d3d5abf.png";

export const DISCLAIMER_TEXT = `L'utente è responsabile della musica/video che invia, con riferimento al regolamento per le competizioni, dei tempi musicali e di coreografia.
La piattaforma e l'organizzazione declinano ogni responsabilità di abusi per Video o Musiche che l'utente invia dei quali non abbia i diritti di utilizzo.

Si consiglia di portare con sé una copia dei File, per eventuali problemi con gli stessi, qualora il DJ Responsabile delle Musiche abbia necessità.`;
